import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import logo from "../Assets/TownLogo/Townbeli-white.webp";

export default function PageLoader() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Show only on first load of the session
    if (sessionStorage.getItem("pageLoaderShown")) {
      setIsLoading(false);
      return;
    }
    sessionStorage.setItem("pageLoaderShown", "true");

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  // Directions for each vertical slice
  const directions = [
    { x: "-120%", y: 0 },
    { x: "120%", y: 0 },
    { x: "-120%", y: 0 },
    { x: "120%", y: 0 },
  ];

  const sliceVariants = (i) => ({
    initial: { opacity: 1, x: 0, y: 0, rotate: 0, scale: 1 },
    animate: {
      opacity: 0,
      x: directions[i].x,
      y: directions[i].y,
      rotate: i % 2 === 0 ? -15 : 15,
      scale: 1.1,
      transition: { duration: 2, ease: "easeInOut", delay: i * 0.15 },
    },
  });

  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          className="fixed inset-0 z-[999999999] flex items-center justify-center pointer-events-none"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.6 } }}
        >
          {/* Logo stays centered */}
          <motion.img
            src={logo}
            alt="logo"
            className="w-52 z-10 pointer-events-auto"
            initial={{ scale: 1 }}
            animate={{ scale: 1.1 }}
            transition={{
              duration: 1,
              repeat: Infinity,
              repeatType: "reverse",
            }}
          />

          {/* 4 Vertical Slices */}
          <div className="absolute inset-0 flex">
            {[...Array(4)].map((_, i) => (
              <motion.div
                key={i}
                className="flex-1 bg-black"
                variants={sliceVariants(i)}
                initial="initial"
                animate="animate"
              />
            ))}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
